import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import { StepperProps } from './types';
import Connector from './Connector';


export default function VerticalStepper(props: StepperProps) {
  const { activeStep, children } = props;  
  return (
    <Box >
      <Stepper activeStep={activeStep} 
        orientation='vertical'
        connector={<Connector />}>
        {children}
      </Stepper>
    </Box>
  );
}
